export var AwsErrorCodes = /*#__PURE__*/ function(AwsErrorCodes) {
    AwsErrorCodes["NotAuthorizedException"] = "NotAuthorizedException";
    AwsErrorCodes["LimitExceededException"] = "LimitExceededException";
    AwsErrorCodes["PasswordResetRequiredException"] = "PasswordResetRequiredException";
    AwsErrorCodes["ExpiredCodeException"] = "ExpiredCodeException";
    AwsErrorCodes["TooManyRequestsException"] = "TooManyRequestsException";
    AwsErrorCodes["InvalidPasswordException"] = "InvalidPasswordException";
    AwsErrorCodes["UserNotFoundException"] = "UserNotFoundException";
    AwsErrorCodes["UsernameExistsException"] = "UsernameExistsException";
    return AwsErrorCodes;
}({});
